// extracted by mini-css-extract-plugin
module.exports = {"menu":"popout-menu_menu__1u320","options":"popout-menu_options__2v-Ml"};